module.exports = __webpack_public_path__ + "media/music_5.f4fe0e2e.mp3";